declare var process : {
  env: {
    NODE_ENV: string
    REACT_APP_OUTPUT_SERVER_PORT: string|undefined
  }
}

const environment= process.env.NODE_ENV as string 
console.log('process.env')
console.log(process.env)

let api_base=''
let basename=''

// if (process.env.REACT_APP_OUTPUT_SERVER_PORT===undefined){
//   api_base="/gsapi/api"
//   basename='/genes'
// }else 
if(! environment|| environment === 'development') {
  api_base="http://localhost:4272/api"
  basename='/'
} else {
  api_base="/api"
  basename='/'
}
// api_base="/api"
// basename='/genes'

console.log(basename)

//The BASENAME is used for react router, otherwise you  get a blank page
//in homepage in package.json, it is used to build the production
export const BASENAME = basename 

export const API_BASE = api_base
export const OUTPUT_SERVER_PORT=7281